import { BCMSDate } from "@bcm-dev/bcms-vite";
import React, { useRef, useState } from "react";
import DatePickerView from "./components/DatePickerView";
import DoubleCalendar from "./components/DoubleCalendar";
import MobileDoubleCalendar from "./components/MobileDoubleCalendar";
import "./styles.css";

export default function DatePicker(props) {
  const ref = useRef();
  const { onChange, showFees, billerType, dueDate, enablePast ,disableToday,disableWeekends,showWords} = props;
  
  const setDate = props.setDate instanceof BCMSDate ? props.setDate : BCMSDate.init();
  const conditionalDisable = props.conditionalDisable instanceof Function ? props.conditionalDisable : () => false;

  const [isActive, setActive] = useState(false);  // Stores if view is rendered
  // Controllers accessible from custom hooK;
  const controllers = {
    "open": () => setActive(true),       // Opens view
    "close": () => setActive(false),      // closes view 
    "set": (value) => onChange(value),   // Sets value of container
    "get": () => setDate,       // Gets value of container
    "toggle": () => setActive(!isActive),  // Toggle view
    "input":() =>props.setDate,
    "showFees": showFees === undefined ? "false" : showFees,
    "billerType": billerType === undefined ? "electronic" : billerType,
    "dueDate" : dueDate instanceof BCMSDate ? dueDate : undefined, 
    "enablePast": enablePast === undefined ? false : enablePast,
    "disableToday":disableToday,
    "disableWeekends":disableWeekends,
    "conditionalDisable":conditionalDisable
  }

  //let disabled = (date) => BCMSDate.init(date).setToFirst().isAfter(BCMSDate.init().setToFirst());

  const disabled = date => {
    const passedDate = BCMSDate.init(date).setToFirst();
    const currentMonth = BCMSDate.init().setToFirst();
    const oneYear = BCMSDate.init().offset([0, 0, 1]).setToFirst();

    return passedDate.isAfter(currentMonth) && passedDate.isBefore(oneYear);
  };

  const leftDisabled = date => enablePast ? true : BCMSDate.init(date).setToFirst().isAfter(BCMSDate.init().setToFirst());
  const rightDisabled = date => BCMSDate.init(date).setToFirst().isBefore(BCMSDate.init().setToFirst().offset([0, 0, 1]));

  const use = props.use instanceof Function
    ? props.use
    : (controllers, children) => React.cloneElement(children, { controllers });

  return (
    <div className="date-picker-container">
      {/*The view of the date picker when closed*/}
      {use(controllers, props.children)}
      {/*Show Double Date Picker if screen is bigger than mobile threshold active*/}
      <div className="double-calendar">{isActive && <DoubleCalendar controllers={controllers} {...props} setDate={setDate} onChange={onChange} disabled={{ leftDisabled, rightDisabled }}/>}</div>
      {/*Show Mobile Double Date Picker if screen is bigger than mobile threshold active*/}
      <div className="mobile-double-calendar">{isActive && <MobileDoubleCalendar controllers={controllers} {...props} setDate={setDate} onChange={onChange} disabled={{ leftDisabled, rightDisabled }} />}</div>
      {/*Transparent overlay to dismiss date picker if clicked outside*/}
      {isActive && <div className="date-picker-overlay" onClick={controllers.close}></div>}
    </div>
  );
}
// :: formatPickerString bcmsDate -> STRING
// Takes a instance of bcmsDate and either returns "Today", "Tomorrow" or the date formatted as a string
export function formatPickerString(date,showWords) {
  showWords = false; //update from cert site appears to remove the words from input but can not verify if permanent  hard setting till we can verify 
  if(date.diff() == 0 && showWords !== false) { return "Today"; }
  else if(date.diff() == 1 && showWords !== false) { return "Tomorrow"; }
  else {
    return date.format("m/d/Y");

    /*return date.yearInt !== BCMSDate.init().yearInt
      ? date.format("M d, Y") : date.format("M d");*/
  }
}


export { DatePickerView };
